/* MOON BASIN WORLDS - CANVAS PRODUCT PAGE controller.
   Simon, 2026-09-07.

   The shirt page never needed this: every size is $50. A canvas is three
   prices, so the price shown has to follow the size the visitor picks, the
   bag button has to reflect that size's availability, and the URL should
   carry the variant so a shared link opens on the right size.

   Also the friction layer for the still: no context menu, no drag.
*/
(() => {
  const init = () => {
    const root = document.querySelector('[data-mb-canvas-product]');
    if (!root) return;

    const select = root.querySelector('select[name="id"]');
    const priceEl = root.querySelector('[data-mb-canvas-price]');
    const button = root.querySelector('.mb-add-to-bag');
    const status = root.querySelector('[data-mb-canvas-status]');
    let variants = [];
    try { variants = JSON.parse(root.dataset.variants || '[]'); } catch (err) {}

    const sync = () => {
      if (!select) return;
      const v = variants.find((x) => String(x.id) === String(select.value));
      if (!v) return;
      if (priceEl) priceEl.textContent = v.price;
      // wall mockup follows the size (10x10 / 20x20 / 30x30), fallback = whatever is there
      const wallImg = root.querySelector('.mb-product__image--view-wall');
      if (wallImg && wallImg.dataset.wallSizes) {
        try {
          const sizes = JSON.parse(wallImg.dataset.wallSizes);
          const key = (String(v.title).match(/(10|20|30)/) || [])[1];
          // nearest available size when the picked one has no wall photo yet
          const order = { '10': ['10x10', '20x20', '30x30'], '20': ['20x20', '30x30', '10x10'], '30': ['30x30', '20x20', '10x10'] }[key] || [];
          const pick = order.map((k) => sizes[k]).find(Boolean);
          if (pick && wallImg.getAttribute('src') !== pick.src) {
            wallImg.src = pick.src;
            wallImg.srcset = pick.srcset;
          }
        } catch (err) {}
      }
      if (button) {
        button.disabled = !v.available;
        button.textContent = v.available ? 'ADD TO BAG' : 'UNAVAILABLE';
      }
      if (status) status.textContent = `${v.title}, ${v.price}`;
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', String(v.id));
        window.history.replaceState({}, '', url.toString());
      } catch (err) {}
    };

    if (select) {
      // Jay 2026-09-07: touching SIZE flips the stage to WALL ART, so nobody
      // thinks the moving picture is what ships. On a phone the native picker
      // opens on the tap and 'change' only fires after, so flip on the tap
      // (pointerdown / focus) as well as on the pick. moon-basin.js owns the
      // state; clicking its own button keeps the rail, aria and status in step.
      const toWall = () => {
        const wall = root.querySelector('[data-mb-product-view="wall"]');
        if (wall && root.dataset.current !== 'wall') wall.click();
      };
      select.addEventListener('pointerdown', toWall);
      select.addEventListener('focus', toWall);
      select.addEventListener('change', () => { sync(); toWall(); });
      sync();
    }

    const stage = root.querySelector('[data-mb-canvas-stage]');
    if (stage) {
      stage.addEventListener('contextmenu', (e) => e.preventDefault());
      stage.addEventListener('dragstart', (e) => e.preventDefault());
    }

    // LIVE ART: the loop runs only while it is the current view, the tab is
    // visible and the stage is on screen. Reduced-motion never starts it, so
    // the poster (the still) is the whole experience there. moon-basin.js
    // flips data-current; we watch that attribute rather than the buttons.
    // Jay 2026-09-07: the shirt page's WALL ART button lands here on the wall
    // view (#wall), so the buyer sees the print, not the moving picture. Done
    // before the loop wakes up so it never starts. (A hash, not ?view=: Shopify
    // reads ?view= as a template switch and served the shirt template.)
    try {
      if (window.location.hash === '#wall') {
        const wall = root.querySelector('[data-mb-product-view="wall"]');
        if (wall && root.dataset.current !== 'wall') wall.click();
      }
    } catch (err) {}

    const loop = root.querySelector('[data-mb-live-loop]');
    if (loop) {
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      let onScreen = true;
      const wanted = () => root.dataset.current === 'art' && !document.hidden && onScreen && !reduce.matches;
      const syncLoop = () => {
        if (wanted()) {
          const p = loop.play();
          if (p && p.catch) p.catch(() => {});
        } else if (!loop.paused) {
          loop.pause();
        }
      };
      new MutationObserver(syncLoop).observe(root, { attributes: true, attributeFilter: ['data-current'] });
      document.addEventListener('visibilitychange', syncLoop);
      if (reduce.addEventListener) reduce.addEventListener('change', syncLoop);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver((entries) => {
          onScreen = entries.some((e) => e.isIntersecting);
          syncLoop();
        }, { threshold: 0.2 }).observe(stage || loop);
      }
      syncLoop();
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
